<template>
  <div class="index_home" v-loading="loading">
    <!-- <div class="header">
      <div class="tab">
        <div class="tab_list">
          <p>市级“双减”案例</p>
          <p v-for="(item, index) in tabList" :key="'tab' + index" :class="{ active: tabName === item }" @click="toTab(item)">{{ item }}</p>
        </div>
      </div>
    </div> -->
    <div class="content" v-if="list.length > 0">
      <div class="caseLogo">
        <img :src="caseLogo" alt="" />
      </div>
      <div class="list">
        <div
          class="list_item"
          v-for="(item, index) in list"
          :key="index"
          @click="listClick(item)"
        >
          <div class="list_item_title">
            <img :src="titleIcon" alt="" /> {{ item.title }}
          </div>
          <div class="list_item_info">
             <span>{{util.timestampToTime(item.publishdate)}}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- <div>

    </div> -->
    <div class="msg" v-if="list.length= 0 && !loading ">
      <img :src="nodataIcon" alt="" />
      <p>暂时没有经验交流文章</p>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { getAccessToken } from "@/utils-khfw/getWHAccessTokenjs";
import util from "@/utils/util.js";
export default {
  name: "cityCaseList",
  components: {},
  props: {},
  data() {
    return {
      titleIcon: require("@/assets/img/title_icon.svg"),
      nodataIcon: require("@/assets/img/nodata.png"),
      caseLogo: require("@/assets/img/case.svg"),
      tabName: "优秀案列",
      tabList: ["优秀案列", "经验交流"],
      list: [],
      loading: true,
      util
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  created() {
    document.title = "市级“双减”案例";
    this.getReduceList();
  },
  methods: {
    async getReduceList() {
      let params = {
        title: "优秀案例",
        pagezize:999,
      };
      let accessToken = await getAccessToken();
      const { data } = await axios.post(
        "https://api.wuhaneduyun.cn/portal/api/school/getreduce?accessToken=" +
          accessToken,
        params
      );
      if (data.retCode == "000000" && data.result) {
        this.list = data.result;
        this.loading=false
      }else{
        this.loading=false
      }
    },
    async listClick(item) {
      let params = {
        id: item.id,
        schoolid: item.schoolid,
      };
      let accessToken = await getAccessToken();
      const { data } = await axios.post(
        "https://api.wuhaneduyun.cn/portal/api/school/getreduceview?accessToken=" +
          accessToken,
        params
      );
      if (data.retCode == "000000" && data.result) {
        this.$router.push({
          path: "/cityCaseContent",
          query: { contentInfo: data.result.content_info },
        });
      }
      //   location.href = item.link||'https://wwp.huijiaoyun.com/Result/index.html#/recomArticle?id=6244f849b21297004152acad';
    },
    toTab(item) {
      this.tabName = item;
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="less" scoped>
.index_home {
  height: 100%;
  overflow-y: auto;
  background-color: #eee;
  .header {
    box-sizing: border-box;
    height: 45px;
    text-align: center;
    .header_title {
      display: flex;
      justify-items: center;
      align-content: center;
      font-size: 18px;
      font-family: PingFang SC;
      font-weight: 600, Semi Bold;
      .title {
        font-weight: 700;
        margin-left: 13%;
      }
    }
    .tab {
      height: 100%;
      display: flex;
      justify-items: center;
      align-content: center;
      .back {
        width: 45px;
        height: 45px;
        line-height: 45px;
      }
      .tab_list {
        height: 50px;
        width: 100%;
        line-height: 50px;
        background-color: #fff;
        p {
          display: inline-block;
          font-size: 14px;
          margin: 0 15%;
          font-size: 17px;
        }
        .active {
          color: #4991e1;
          border-bottom: 2px solid #4991e1;
        }
      }
    }
  }

  .content {
    .caseLogo {
      width: 100%;
      margin-top: 5%;
      text-align: center;
    }
    .list {
      height: 100px;
      margin: 5% auto;
      width: 95%;
      font-family: PingFang SC;
      font-weight: 400, Regular;
      .list_item {
        width: 100%;
        padding: 5%;
        margin-bottom: 3%;
        background-color: #fff;
        border-radius: 5px;
        .list_item_title {
          font-weight: 500;
          font-size: 17px;
          display: -webkit-box; //将对象作为弹性伸缩盒子模型显示。
          -webkit-box-orient: vertical; //从上到下垂直排列子元素（设置伸缩盒子的子元素排列方式）
          -webkit-line-clamp: 2; //限制行数
          overflow: hidden; //超出部分隐藏
          text-overflow: ellipsis; //用一个省略号代替超出的内容
        }
        .list_item_info {
          margin-top: 5%;
          font-size: 12px;
          color: #9b9b9b;
          span {
            margin: 2%;
          }
        }
      }
    }
  }
  .msg {
    text-align: center;
    margin-top: 30%;
    img {
      width: 80px;
      height: 90px;
    }
    p {
      font-size: 17px;
      color: #b2b2b2;
    }
  }
}
</style>
